import React from 'react';
import { styled } from '@mui/material/styles';
import { List, ListItem, ListItemText, IconButton, Tooltip } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';


const PREFIX = 'ListAll';

const classes = {
  list_all: `${PREFIX}-list_all`,
  list_item: `${PREFIX}-list_item`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.list_all}`]: {
    alignItems: 'center',
    // padding: theme.spacing(6, 1, 0, 0),
    border: 'solid 2px',
    minWidth: '25rem',
    maxWidth: '25rem',
    maxHeight: '30rem',
    minHeight: '30rem',
    overflow: 'auto',
  },

  [`& .${classes.list_item}`]: {
    paddingLeft: '5px',
    display: 'flex',
    minHeight: '2.5rem',
    borderBottom: 'solid 1px',
  }
}));

//Function that pulls the data and sends it to the Table Renderer
const ListAll = props => {
    let {loading, allList, add} = props;

    return (
      <Root>
        {loading ? (
          <>
          </>
        ) : (
          <List className={classes.list_all}>
          {allList.map(elem => {
            return (
              <>
                <ListItem key={elem.assignment_resource} class={classes.list_item}>
                  <ListItemText primary={elem.full_name} />
                  <Tooltip title="Add to List">
                    <IconButton color="none" size="large"><AddCircleIcon onClick={() => add(elem.assignment_resource, elem.full_name)}/></IconButton>
                  </Tooltip>
                </ListItem>
              </>
            );
          })}
        </List>
    )}
      </Root>
    );
};


export default ListAll;